import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';
import { observer } from 'mobx-react';

class EstimateLabour extends Component {
  state = {}
  render() { 
    const { estimate } = this.props
    return (
      <Table striped compact='very'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Operation</Table.HeaderCell>
            <Table.HeaderCell>Setup</Table.HeaderCell>
            <Table.HeaderCell>Operation</Table.HeaderCell>
            <Table.HeaderCell>Extra</Table.HeaderCell>
            <Table.HeaderCell>Total</Table.HeaderCell>
            {!this.props.noDollarValue &&
              <Table.HeaderCell>$</Table.HeaderCell>
            }
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {estimate.labour.map((operation, index) => (
            <Table.Row key={index}>
              <Table.Cell>{operation.description}</Table.Cell>
              <Table.Cell>{operation.setupMinutes} min</Table.Cell>
              <Table.Cell>{operation.operationMinutes} min</Table.Cell>
              <Table.Cell>{operation.extraMinutes} min</Table.Cell>
              <Table.Cell>{operation.totalMinutes} min</Table.Cell>
              {!this.props.noDollarValue &&
                <Table.Cell>${operation.totalDollars.toFixed(2)}</Table.Cell>
              }
            </Table.Row>
          ))}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan={4} />
            <Table.HeaderCell><strong>{estimate.sumLabourMinutes()} min</strong></Table.HeaderCell>
            {!this.props.noDollarValue &&
              <Table.HeaderCell><strong>${estimate.sumLabourDollars().toFixed(2)}</strong></Table.HeaderCell>
            }
          </Table.Row>
        </Table.Footer>
      </Table>
    )
  }
}
 
export default observer(EstimateLabour);


// WEBPACK FOOTER //
// ./src/components/jobs/EstimateLabourTable.js